import PageContainer from "../components/PageContainer";
import photo1 from '../static/images/partner/1.jpg';
import photo2 from '../static/images/partner/2.jpg';
import photo3 from '../static/images/partner/3.jpg';
import photo4 from '../static/images/partner/4.jpg';
import { YellowButton } from "../components/buttons";
import { Link, useNavigate } from "react-router-dom";
import { useDispatch } from "react-redux";
import { setBacklink } from "../redux/backlinkSlice";
import { Helmet } from 'react-helmet';
import usePageTracking from "../hooks/usePageTracking";

const PartnerPage = () => {

    const { pageTitle, description } = usePageTracking({
        pageTitle: "Partner",
    })

    const navigate = useNavigate();
    const dispatch = useDispatch();
    const handleClick = () => {
        dispatch(setBacklink("/partner-page"));
        navigate("/partner-terms-and-conditions");
    }

    return (
        <PageContainer items="center" px="4">
            <Helmet>
                <title>{pageTitle} - TicinoWild</title>
                <meta name="description" content="Diventa partner di TicinoWild oggi stesso ed espandi la tua visibilità nel mercato delle attività outdoor" />
            </Helmet>
            <div className="max-w-[560px]">
                <h3 className="text-[#225424] text-center">Espandi il tuo business e accresci la tua visibilità nel mercato delle attività outdoor:</h3>
                <div className="text-xl font-bold text-center">diventa partner di <span className="font-signature text-2xl text-[#b05704]">TicinoWild</span> oggi stesso!</div>
            </div>
            <div className="flex flex-col md:flex-row gap-2 mt-8">
                <div className="flex flex-row gap-2 justify-center">
                    <div>
                        <div className="w-[160px] h-[160px] overflow-hidden"><img src={photo1} alt="foto partner 1" className="h-full w-full object-cover rounded-xl" /></div>
                        <div className="h-[50px]"></div>
                    </div>
                    <div>
                        <div className="h-[50px]"></div>
                        <div className="w-[160px] h-[160px] overflow-hidden"><img src={photo2} alt="foto partner 2" className="h-full w-full object-cover rounded-xl" /></div>
                    </div>
                </div>
                <div className="flex flex-row gap-2 justify-center mt-[-50px] md:mt-0">
                    <div>
                        <div className="w-[160px] h-[160px] overflow-hidden"><img src={photo3} alt="foto partner 3" className="h-full w-full object-cover rounded-xl" /></div>
                        <div className="h-[50px]"></div>
                    </div>
                    <div>
                        <div className="h-[50px]"></div>
                        <div className="w-[160px] h-[160px] overflow-hidden"><img src={photo4} alt="foto partner 4" className="h-full w-full object-cover rounded-xl" /></div>
                    </div>
                </div>
            </div>

            <div className="flex flex-col gap-8 max-w-[600px] mt-8">
                <h4 className="font-normal">Vantaggi esclusivi per i partner TicinoWild:</h4>
                <div>
                    <h4 className="text-[#225424]">Maggiore visibilità</h4>
                    <p>
                        Accedi a una piattaforma dedicata e ben strutturata che promuove le tue attività outdoor a un vasto pubblico, aumentando la tua notorietà e attrattività.
                    </p>
                </div>
                <div>
                    <h4 className="text-[#225424]">Riduzione del lavoro amministrativo</h4>
                    <p>
                        Risparmia tempo e risorse nella gestione di prenotazioni e transazioni, concentrandoti sulla tua attività principale.
                    </p>
                </div>
                <div>
                    <h4 className="text-[#225424]">Semplicità di prenotazione</h4>
                    <p>
                        Offri ai tuoi clienti un'esperienza di prenotazione semplice e intuitiva grazie
                        all'interfaccia user-friendly di TicinoWild.
                    </p>
                </div>
                <div>
                    <h4 className="text-[#225424]">Massima flessibilità</h4>
                    <p>
                        Mantieni pieno controllo sulle tue offerte: stabilisci liberamente prezzi e politiche di cancellazione in base alle tue esigenze.
                    </p>
                </div>
                <div>
                    <h4 className="text-[#225424]">Nessun costo di iscrizione o abbonamento</h4>
                    <p>
                        Diventa partner gratuitamente e inserisci subito le tue attività sulla piattaforma per raggiungere nuovi clienti. Paghi solo una commissione del 15% su ogni prenotazione ricevuta, senza costi fissi.
                    </p>
                </div>
                <div>
                    <h4 className="text-[#225424]">Gestione sicura dei pagamenti</h4>
                    <p>
                        Ricevi i pagamenti in modo rapido e sicuro direttamente sul tuo conto ad ogni prenotazione.
                    </p>
                </div>
                <div>
                    <h4 className="text-[#225424]">Rete di Collaborazione</h4>
                    <p>
                        Entra a far parte di una rete dinamica di fornitori e professionisti del settore outdoor, con opportunità di collaborazione e crescita condivisa.
                    </p>
                </div>
                <p className="underline cursor-pointer text-[#225424] w-fit" onClick={handleClick}>
                    Termini e condizioni
                </p>
            </div>
            <div className="mt-8">
                <Link to="https://forms.gle/iaEmYH2kNB7M2Gg59" target="_blank"><button className='bg-[#fbd100] text-white font-bold py-4 px-8 md:py-2 text-xl md:text-sm rounded-xl'>Inizia subito</button></Link>
            </div>
        </PageContainer>
    )
}

export default PartnerPage